// extracted by mini-css-extract-plugin
export default {"container":"JoinTeam_container__J+Kwl","centered":"JoinTeam_centered__34g3i"};